"use strict";

import axios from "axios";
import qs from 'qs'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import {useUserStore} from '@/stores/user'
import {ElMessage} from 'element-plus'
import {useAppStore} from "@/stores/app";

let config = {
    // baseURL: process.env.baseURL || process.env.apiUrl || ""
    // timeout: 60 * 1000, // Timeout
    // withCredentials: true, // Check cross-site Access-Control
};

const _axios = axios.create(config);

_axios.interceptors.request.use(
    function (config) {

        if (!config.url.startsWith('/api') && !config.url.includes(window.location.hostname)) {
            return config;
        } else {
            let token = useUserStore().getToken;
            if (token) config.headers.Authorization = token;
            if (!config.url.includes("hasWorkFlow") && !config.url.includes('/schedule/usage')
                && !config.url.includes('loginByTicket') && !config.url.includes('createLoginTicket'))
                NProgress.start()
            return config;
        }
    },
    function (error) {
        // Do something with request error
        return Promise.reject(error);
    }
);

// Add a response interceptor
_axios.interceptors.response.use(
    function (response) {
        NProgress.done()

        //登录超时
        if (response.data.code === 401) {
            useAppStore().setLastUrl(window.location.pathname)
            alert(JSON.stringify(response.data))
            window.location.href = "/";
            if (response.data.message) ElMessage(response.data.message)
        } else if (response.data.code === 510) {
            if (response.data.message) ElMessage(response.data.message)
        } else if (response.data.code === 511) {
            console.error('Server 511: ' + response.data.message)
        }

        return response;
    },
    function (error) {
        // Do something with response error
        return Promise.reject(error);
    }
);

export function get(url, params = {}, headers = {}) {
    return new Promise((resolve, reject) => {
        _axios.get(url, {
            params: params,
            headers: headers
        })
            .then(response => {
                resolve(response.data);
            })
            .catch(err => {
                reject(err)
            })
    })
}

//application/x-www-form-urlencoded
export function post(url, data = {}, headers = {}) {
    return new Promise((resolve, reject) => {
        _axios.post(url, qs.stringify(data), {headers})
            .then(response => {
                resolve(response.data);
            }).catch(err => {
            reject(err)
        })
    })
}

// application/json
export function post2(url, data = {}, headers = {}) {
    return new Promise((resolve, reject) => {
        _axios.post(url, data, {headers})
            .then(response => {
                resolve(response.data);
            }).catch(err => {
            reject(err)
        })
    })
}

// form-data
export function post3(url, formData, headers = {}) {
    return new Promise((resolve, reject) => {
        _axios.post(url, formData, {
            headers: {
                ...headers,
                'Content-Type': 'multipart/form-data'
            }
        }).then(response => {
            resolve(response.data);
        }).catch(err => {
            reject(err);
        });
    });
}


export function upload(url, formData) {
    return new Promise((resolve, reject) => {
        _axios.post(url, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then(response => {
            resolve(response.data);
        }).catch(err => {
            reject(err)
        })
    })
}

export function download(fileName, url, params = {}, beforeCallback, afterCallback, method = 'get') {

    return new Promise((resolve, reject) => {
        if (beforeCallback) beforeCallback()

        let config = {
            headers: {'Content-Type': 'application/json'},
            responseType: 'blob',
            method,
            url: url,
            timeout: 60000
        };

        if (method === 'post') {
            config.data = params;
        } else {
            config.params = params;
        }

        _axios(config).then(response => {
            let link = document.createElement('a')
            let blob = new Blob([response.data])
            link.style.display = 'none'
            link.href = URL.createObjectURL(blob)
            link.download = fileName
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
            if (afterCallback) afterCallback()
        }).catch(err => {
            reject(err)
        })
    });
}

export function put(url, data = {}, headers = {}) {
    return new Promise((resolve, reject) => {
        _axios.put(url, data, {headers})
            .then(res => {
                resolve(res.data)
            })
            .catch(err => {
                reject(err)
            })
    });
}

export function put2(url, params, headers = {}) {
    return new Promise((resolve, reject) => {
        _axios({
            method: 'put',
            url: url,
            data: qs.stringify(params),
            headers: headers
        }).then(res => {
            resolve(res.data)
        }).catch(err => {
            reject(err)
        })
    })
}

export function $delete(url, params, headers = {}) {
    return new Promise((resolve, reject) => {
        return _axios({
            method: 'delete',
            url,
            params,
            headers
        }).then(res => {
            resolve(res.data)
        }).catch(err => {
            reject(err)
        })
    });
}

